module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('panel', {
    attrs: {
      "title": _vm.title
    }
  }, [(!_vm.product.variationsCombination) ? _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--sm btn--info btn-history",
    on: {
      "click": function($event) {
        return _vm.showPriceHistory(_vm.product.variations[0].sku)
      }
    }
  }, [_c('i', {
    staticClass: "icon-folder-search"
  }), _vm._v(" "), _c('span', [_vm._v("Histórico de alteração de preços")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.variations), function(variation) {
    return (_vm.product.variationsCombination) ? _c('variation-type-multi', {
      key: variation,
      attrs: {
        "productId": _vm.product.productId,
        "variation": variation,
        "sourceVariation": _vm.getSourceVariation(variation),
        "category": _vm.category,
        "fromModule": _vm.product.source,
        "product": _vm.product
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.product.variationsCombination) ? _c('variation-type-single', {
    attrs: {
      "productId": _vm.product.productId,
      "variation": _vm.product.variations[0],
      "sourceVariation": _vm.getSourceVariation(_vm.product.variations[0]),
      "category": _vm.category,
      "fromModule": _vm.product.source
    }
  }) : _vm._e(), _vm._v(" "), _c('modal-price-history', {
    attrs: {
      "sku": _vm.skuModal,
      "module": {
        'type': 'marketplace',
        'identifier': 'mercadoLivre'
      },
      "code": _vm.product.code
    },
    model: {
      value: (_vm.modalPriceHistory),
      callback: function($$v) {
        _vm.modalPriceHistory = $$v
      },
      expression: "modalPriceHistory"
    }
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-703de956","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/edit/Variation.vue
// module id = 3283
// module chunks = 0